<app-modal-view
  #modal="modal"
  modalTitle="Miles Per Year Calculator">

  <app-miles-per-year-calculator modal-body></app-miles-per-year-calculator>

</app-modal-view>
